module.exports = __webpack_public_path__ + "static/img/detail_alien_02.384ff5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/aliens-vs-predator-microsite/detail_alien_02.jpg
// module id = 221
// module chunks = 2